import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Toasted from 'vue-toasted';
import { Duty } from "../../backend/backendapi";
import { massEditDuty } from "../dutyui.util";

Vue.use(Toasted, { duration: 2000 });

@Component({
    name: 'DueTimespanModal',
    components: {}
})
export default class DueTimespanModal extends Vue {
    @Prop({ required: true })
    readonly duties!: Duty[];

    private dueSeconds: number = 0;

    open(): void {
        $(this.$refs.modal!).modal('show');
        setTimeout(() => (this.$refs.createButton as HTMLButtonElement).focus(), 500);
        this.selectMostCommonValue();
    }

    dismiss(): void {
        $(this.$refs.modal!).modal('hide');
    }

    private async save(): Promise<void> {
        const stats = await massEditDuty(this.duties, (dutyCreate) => {
            dutyCreate.duty.dueSeconds = this.dueSeconds;
        }, this.$toasted, this.$i18n);
        this.$emit('saved', stats);
        if (stats.failed === 0) {
            this.dismiss();
        }
    }

    private selectMostCommonValue() {
        //compute most selected value among the duties
        const occur = this.duties.map(e => e.advancedReminderHours)
            .reduce((acc, v) => acc.set(v, (acc.get(v) ?? 0) + 1), new Map<number, number>()); //count occurences of values
        const sorted = Array.from(occur.entries()).sort((l, r) => r[1] - l[1]);//sort desc by value

        if (sorted.length > 0) {
            this.dueSeconds = sorted[0][0];//use most selected value among the duties
        } else {
            this.dueSeconds = 0;
        }
    }

    //computed
    private get dueWeeks(): number {
        return Math.floor(this.dueSeconds / 3600 / 24 / 7);
    }

    private set dueWeeks(val: number) {
        let diff = val - this.dueWeeks;
        this.dueSeconds += diff * 3600 * 24 * 7;
    }

    private get dueDays(): number {
        return Math.floor(this.dueSeconds / 3600 / 24) % 7;
    }

    private set dueDays(val: number) {
        let diff = val - this.dueDays;
        this.dueSeconds += diff * 3600 * 24;
    }

    private get dueHours(): number {
        return Math.floor(this.dueSeconds / 3600) % 24;
    }

    private set dueHours(val: number) {
        let diff = val - this.dueHours;
        this.dueSeconds += diff * 3600;
    }
}